import { Component, OnInit } from '@angular/core';

import { IChatManager } from "../services/chat/chat-manager";
import { ChatParserService } from "../services/chat/chat-parser.service";
import { WsService2 } from '../services/ws/ws.service';
import { RoomManagerService } from "../services/room/room-manager.service";
import {

  Input,
  trigger,
  state,
  style,
  transition, keyframes,
  animate,
} from '@angular/core';
declare var $;
import { WsService } from '../../utils/network/ws.service';
@Component({
  selector: "dskl-chat",
  styleUrls: ["style.css"],
  animations: [
    trigger('flyInOut', [
      state('in', style({

        bottom: 10, right: 10
      })),
      state('out', style({
        bottom: -336, right: 10
      })),
      transition('in => out', [
        animate(300, keyframes([
          style({ bottom: 10, right: 10, offset: 0 }),
          style({ bottom: -376, right: 10, offset: 0.3 }),
          style({ bottom: -336, right: 10, offset: 1.0 })
        ]))
      ]),
      transition('out => in', [
        animate(300, keyframes([
          style({ bottom: -336, right: 10, offset: 0 }),
          style({ bottom: 50, right: 10, offset: 0.7 }),
          style({ bottom: 10, right: 10, offset: 1.0 })
        ]))
      ])
    ])


  ], templateUrl: "chat.component.html"
})
export class ChatComponent implements IChatManager {

  toggle = "in";
  constructor(private chatParser: ChatParserService, private roomManagerService: RoomManagerService, private wsService: WsService2) {
    chatParser.setChatManager(this);

  }
  chatMessages = 0;
  notMe(k) {

    return k != this.wsService.getMe()
  }
 // prs = ["kondio","mondio","fondio","bondio","trondio","shlondio", "kondio","mondio","fondio","bondio","trondio","shlondio", "kondio","mondio","fondio","bondio","trondio","shlondio", "kondio","mondio","fondio","bondio","trondio","shlondio", "kondio","mondio","fondio","bondio","trondio","shlondio"]
  peerKeys() {
    return Object.keys(this.roomManagerService.peers);
   //  return Object.keys(this.prs);
  }
  peers(k) {
    return this.roomManagerService.peers[k];
  //   return {name: this.prs[k], chatMessages:[]}
  }
  to() {

    console.log(this.toggle)
    this.toggle = this.toggle == 'in' ? 'out' : 'in'
  }
  sendMessage(msg) {
    this.chatParser.sendMessage(msg, this.currentSender);
    $("#messages").animate({ scrollTop: $('#messages').prop("scrollHeight") }, 200);

  }

  static ROOM_SENDER = "all"
  currentSender = ChatComponent.ROOM_SENDER;
  last;
  currentName() {
    if (this.currentSender == ChatComponent.ROOM_SENDER) {
      return "";

    } else {
      try{

       return this.peers(this.currentSender).name;
      }catch(error){
        
        this.currentSender = ChatComponent.ROOM_SENDER;
        return "";
      }
    }
  }
  onMessage(from, name, message, me, isPrivate) {
    this.last = from;
    var key;
    if (!isPrivate) {
      key = ChatComponent.ROOM_SENDER;
    } else {
      if (!me)
        key = from;
      else key = this.currentSender
    }
    if (!this.messages[key])
      this.messages[key] = [];
    this.messages[key].push({ name: name, msg: message, me: me });

    if (!me && this.toggle != "in") {
      this.to()
    }
    if (key == this.currentSender)
      $("#messages").animate({ scrollTop: $('#messages').prop("scrollHeight") }, 200);
    else {
      if (key == "all") {
        this.chatMessages++;
      } else {
        if (!this.roomManagerService.peers[key].chatMessages)
          this.roomManagerService.peers[key].chatMessages = 0;
        this.roomManagerService.peers[key].chatMessages++;
      }
    }
  }

  selected(p) {
    this.currentSender = p;
    if (p == "all")
      this.chatMessages = 0;
    else
      this.roomManagerService.peers[p]["chatMessages"] = 0;
    
    setTimeout(function() {
      $("#messages").animate({ scrollTop: $('#messages').prop("scrollHeight") }, 200);
    }, 100);

  }
  hasLinks(msg) {
    return /(https?:\/\/[^\s]+)/g.test(msg);
  }

  findUrls(message) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return message.replace(urlRegex, function (url) {
      return '<a target="_blank" class="chat-link" style="color:white;" href="' + url + '">' + url + '</a>';
    })
    // or alternatively
    // return text.replace(urlRegex, '<a href="$1">$1</a>')
  }

  messages = { all: [] };
}



// WEBPACK FOOTER //
// /app/src/app/wb/chat/chat.component.ts